//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../no/Builder.js";
import "../no/SelectFace.js";
import "../no/SelectObject.js";
let d=[[[0,"OffsetRelations",1,0],[1,"RelatedFace",0,"SelectFace",0]],[[["feature"],"LockConstraint",{},1,0],[["feature"],"UnlockConstraint",{},1,0],[["feature"],"DeleteConstraint",{},1,0],[["offsetFaces"],"DeleteOffsetRelation",{},1,0],[[],"UnlockAllConstraints",{},0,0],[[],"DeleteAllConstraints",{},0,0],[[],"DeleteAllOffsetRelationOnBody",{},0,0]],[]];
SPLM.Features.ShowRelatedFacesBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShowRelatedFacesBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;